import React, { useMemo } from 'react';
import { Select } from '@fx-ui/fine-design';
import { makeArray, map, MemberFieldOption } from '@libs/shared';

interface MemberFieldSelectProps {
    className?: string;
    style?: React.CSSProperties;
    value?: string | string[] | null | undefined;
    onChange?: (value: string | string[] | null | undefined) => void;
    multiple?: boolean;
    autoPop?: boolean;
    disabled?: boolean;
    placeholder?: string;
    options?: MemberFieldOption[];
}

const MemberFieldSelect: React.FC<MemberFieldSelectProps> = (props) => {
    const { value, onChange, multiple = true, autoPop, options, ...otherProps } = props;

    const selectOptions = useMemo(() => {
        return map(options, (item) => ({
            value: item.value,
            label: item.text
        }));
    }, [options]);

    return (
        <Select
            showSearch
            allowClear
            value={multiple ? makeArray(value) : value}
            onChange={(value) => {
                if (multiple) {
                    onChange?.(makeArray(value));
                } else {
                    onChange?.(value ?? null);
                }
            }}
            multiple={multiple}
            defaultVisible={autoPop}
            options={selectOptions}
            {...otherProps}
        />
    );
};

export default MemberFieldSelect;
